import type { WebhookRegistration } from "../api";

export function hasWebhookError(registration: WebhookRegistration): boolean {
  return (
    (registration.errorState && registration.errorState !== "None") ||
    !!registration.errorMessage
  );
}
